import { ResetPasswordPage as SharedResetPasswordPage } from "@retro-ia/shared/password";
import { ThemeToggle } from "@/shared/components/ui/themeToggle";
import logo from "@/assets/LOGO-RETRO-IA.png";

export function ResetPasswordPage() {
  return <SharedResetPasswordPage logo={logo} themeToggle={<ThemeToggle />} />;
}
